import { BulletList, Container, cssVar, Header, useAlignments, useSizes } from 'metrix-common3';
import styled from 'styled-components';

const MessagesContainer = styled(Container)`
    ${({ outline }) =>
        outline &&
        `
        border: 1px solid ${cssVar.colorStrokeLight};
        border-radius: 4px;
        padding: 10px;`}
`;

const ProfileMessages = (props) => {
    const alignments = useAlignments();
    const sizes = useSizes();

    return (
        <MessagesContainer {...props}>
            {props.title && (
                <Header size={props.titleSize || sizes.sm} textAlign={alignments.left} text={props.title} />
            )}
            <BulletList key={Math.random().toString()} references={props.messages} size={props.size || sizes.md} />
        </MessagesContainer>
    );
};

export default ProfileMessages;
